import React from "react";
import PropTypes from "prop-types";

const MenuIcon = ({ className = undefined, style = {}, stroke = "#030E0E", defaultWidth = 24, defaultHeight = 24 }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={style && style.width ? style.width : defaultWidth}
      height={style && style.width ? style.height : defaultHeight}
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="menu" fill="black">
        <path id="Vector" d="M3 12H21" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path id="Vector_2" d="M3 6H21" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path id="Vector_3" d="M3 18H21" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
    </svg>
  );
};

MenuIcon.propTypes = {
  className: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types, react/require-default-props
  style: PropTypes.object,
  stroke: PropTypes.string,
  defaultWidth: PropTypes.number,
  defaultHeight: PropTypes.number,
};

export default MenuIcon;
